"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SearcherFormFilters = _interopRequireDefault(require("../SearcherFormFilters"));
var _DatesCarousel = _interopRequireDefault(require("./DatesCarousel"));
var Searcher = function Searcher(_ref) {
  var _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$fetching = _ref.fetching,
    fetching = _ref$fetching === void 0 ? false : _ref$fetching,
    dates = _ref.dates,
    carouselDate = _ref.carouselDate,
    onChangeCarouselDate = _ref.onChangeCarouselDate,
    onPriceDemand = _ref.onPriceDemand,
    _ref$hideFilters = _ref.hideFilters,
    hideFilters = _ref$hideFilters === void 0 ? false : _ref$hideFilters,
    addServicesFilters = _ref.addServicesFilters,
    activeFilters = _ref.activeFilters,
    onSubmitFilters = _ref.onSubmitFilters,
    startDate = _ref.startDate,
    SearcherStatus = _ref.SearcherStatusComponent,
    currentSearchTypeTab = _ref.currentSearchTypeTab,
    searchType = _ref.searchType,
    isOpenFiltersList = _ref.isOpenFiltersList,
    clearSearcherFilters = _ref.clearSearcherFilters;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !(searchType === 'hotel') && currentSearchTypeTab === 'package' ? /*#__PURE__*/_react["default"].createElement(_DatesCarousel["default"], {
    dates: dates,
    startDate: startDate,
    carouselDate: carouselDate,
    onPriceDemand: onPriceDemand,
    onChangeCarouselDate: onChangeCarouselDate,
    fetching: fetching,
    isMobile: isMobile
  }) : null, /*#__PURE__*/_react["default"].createElement(FiltersRow, {
    isMobile: isMobile
  }, !hideFilters && /*#__PURE__*/_react["default"].createElement(_SearcherFormFilters["default"], {
    isMobile: isMobile,
    addServicesFilters: addServicesFilters,
    activeFilters: activeFilters !== null && activeFilters !== void 0 ? activeFilters : {},
    onSubmitFilters: onSubmitFilters,
    isHotelOnly: searchType === 'hotel',
    isOpenFiltersList: isOpenFiltersList,
    clearSearcherFilters: clearSearcherFilters
  }), SearcherStatus && /*#__PURE__*/_react["default"].createElement(SearcherStatus, null)));
};
var FiltersRow = _styledComponents["default"].div.withConfig({
  displayName: "Searcher__FiltersRow",
  componentId: "sc-ogjtgz-0"
})(["display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;margin-top:10px;"]);
var _default = exports["default"] = Searcher;